import React, {useState, useRef, useEffect} from 'react';
import post from '../utils/post.js';
import FormText from './FormText.js';
import FormImage from './FormImage.js';
import clipboard from '../utils/clipboard.js';
import ConfirmPopup from './ConfirmPopup.js';
import usePopupAnimation from '../utils/usePopupAnimation.js';

export default function EshopItemEdit({showEdit, closeEdit, updateEshopItemRowEdit, updateEshopItemRowDelete, data}) {
	const popupAnimationMs = 300;
	const [loading, setLoading] = useState(false);
	const [name, setName] = useState('');
	const [nameError, setNameError] = useState('');
	const [sortorder, setSortorder] = useState('');
	const [sortorderError, setSortorderError] = useState('');
	const [price, setPrice] = useState('');
	const [priceError, setPriceError] = useState('');
	const [img, setImg] = useState('');
	const [imgError, setImgError] = useState('');
	const [qrcode, setQrcode] = useState('');
	const [qr, setQr] = useState('');
	const [showConfirmPopup, setShowConfirmPopup] = useState(false);

	const nameRef = useRef(null);
	const sortorderRef = useRef(null);
	const priceRef = useRef(null);
	const {shouldRender, isClosing} = usePopupAnimation(showEdit, popupAnimationMs);

	useEffect(() => {
		setName('');
		setSortorder('');
		setPrice('');
		setImg('');
		setQrcode('');
		setQr('');
	}, [showEdit]);

	useEffect(() => {
		setName(data.NAME || '');
		setSortorder(data.SORTORDER || '');
		setPrice(data.PRICE || '');
		setImg(data.IMG || '');
		setQrcode(data.QRCODE || '');
		setQr(data.QR || '');

		setNameError('');
		setSortorderError('');
		setPriceError('');
		setImgError('');
	}, [data]);

	const handleSubmit = (e) => {
		e.preventDefault();

		setNameError('');
		setSortorderError('');
		setPriceError('');
		setImgError('');

		let localError = 0;

		if (!name) {
			localError = 1;
			setNameError('povinné');
			nameRef.current.focus();
		}

		if (!sortorder) {
			if (localError === 0) {
				sortorderRef.current.focus();
			}
			localError = 1;
			setSortorderError('povinné');
		}

		if (!price) {
			if (localError === 0) {
				priceRef.current.focus();
			}
			localError = 1;
			setPriceError('povinné');
		}

		if (localError === 0) {
			setLoading(true);

			post('saveItemOld', {NAME: name, SORTORDER: sortorder, PRICE: price, IMG: img, ID: data.ID})
				.then((res) => {
					closeEdit();

					if (res.data === 1) {
						updateEshopItemRowEdit({ID: data.ID, NAME: name, SORTORDER: sortorder, PRICE: price, IMG: img, SHOWINWALLET: data.SHOWINWALLET, QR: qr, QRCODE: qrcode});
					}

					setLoading(false);
				})
				.catch((error) => {
					console.error(error);
					setLoading(false);
				});
		}
	};

	const handleConfirmPopup = (e) => {
		e.preventDefault();
		setShowConfirmPopup(true);
	};

	const closeConfirmPopup = () => {
		setShowConfirmPopup(false);
	};

	const deleteConfirmPopup = () => {
		setLoading(true);

		post('deleteItem', {ID: data.ID})
			.then((res) => {
				closeConfirmPopup();
				closeEdit();
				updateEshopItemRowDelete(data.ID);
				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	return (
		<>
			<ConfirmPopup showConfirmPopup={showConfirmPopup} showButtonDelete deleteConfirmPopup={deleteConfirmPopup} closeConfirmPopup={closeConfirmPopup} infoHeader="Smazání záznamu" infoMain="Opravdu chceš smazat tento záznam?" />

			{shouldRender ? (
				<div className={`popup${isClosing ? ' popup--closing' : ''}`}>
					<div className={`popup_content${isClosing ? ' popup_content--closing' : ''}`}>
						<form method="POST" onSubmit={handleSubmit}>
							<div className="popup_content_in_head">
								<div className="popup_content_in_head_in">Editace zboží</div>
								<img
									alt=""
									className="popup_content_in_head_in-close"
									onClick={() => {
										closeEdit();
									}}
								/>
							</div>
							<div className="popup_content_in_body">
								<div className="popup_content_in_body_in">
									<FormText type="text" label="Název" value={name} setValue={setName} ref={nameRef} error={nameError} />

									<div className="fl_l" style={{width: '48%'}}>
										<FormText type="text" label="Pořadí" value={sortorder} setValue={setSortorder} ref={sortorderRef} error={sortorderError} />
									</div>
									<div className="fl_r" style={{width: '48%'}}>
										<FormText type="text" label="Cena" value={price} setValue={setPrice} ref={priceRef} error={priceError} />
									</div>

									<FormImage label="Obrázek" value={img} setValue={setImg} error={imgError} entityName={name} />

									<div className="zero h1" />
									<div className="qrcode smaller cr_p" id="QRCODE" onClick={() => clipboard(qrcode)} />
									<div className="cr_p" style={{backgroundColor: '#ffffff', padding: '10px', display: 'inline-block'}} onClick={() => clipboard(qrcode)} dangerouslySetInnerHTML={{__html: qr}}></div>

									<div className="zero h1" />
									<div className="cr_p" onClick={() => clipboard(qrcode)}>
										{qrcode}
									</div>

									<div className="zero h1" />
								</div>
							</div>
							<div className="popup_content_in_foot">
								<div className="popup_content_in_foot_in">
									<input type="submit" name="button_save" value="Uložit" className="button green mr_2" disabled={loading} />
									<button
										type="button"
										className="button red mr_2"
										onClick={(e) => {
											handleConfirmPopup(e);
										}}
									>
										Smazat
									</button>
									<button
										type="button"
										className="button"
										onClick={() => {
											closeEdit();
										}}
									>
										Zpět
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			) : (
				''
			)}
		</>
	);
}
